import { render, staticRenderFns } from "./ArgonImport.vue?vue&type=template&id=2b9b7de1&"
import script from "./ArgonImport.vue?vue&type=script&lang=js&"
export * from "./ArgonImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports